import { select, selectAll } from 'd3-selection';
import { createModalLaunchButton } from './abstract-dialog.mjs';


function addLightningTable(talks) {
  const lightningTalks = Array.from(talks.values())
    .filter(t => t.type === 'lightning')
    .sort(function(a, b) {
      return a.speakers[0].alpha.localeCompare(b.speakers[0].alpha);
    });

  if (!lightningTalks.length) {
    selectAll('#lightning-talks, #lightning-talks ~ table').remove();
    return;
  }

  const tbody = select('#lightning-talks ~ table tbody');

  tbody.selectAll('tr.lightning-speaker')
    .data(lightningTalks)
    .enter()
    .append('tr')
    .attr('class', 'lightning-speaker')
    .each(function(d) {
      const tr = select(this);
      tr.attr('id', `${d.id}`);

      const names = d.speakers.map(d => d.name);

      tr.append('td').text(names.join(' and '));
      const td = tr.append('td');

      if (d.title) {
        if (d.abstract) {
          const i = d.title.lastIndexOf(' ');
          
          td.append('span')
            .text(d.title.slice(0, i));

          const span = td.append('span')
            .text(d.title.slice(i))
            .style('display', 'inline-block')
            .style('white-space', 'pre');
          
          createModalLaunchButton(span, d.id);
        }
        else {
          td.text(d.title);
        }
      }
      else {
        td.append('em').text('TBC');
      }
    });
}


export { addLightningTable };
